import { segment } from '@nw/shared/utils';

import { clearUserSession } from '../AccountsStorageUtils';

export const clearUserSessionAndReload = () => {
  clearUserSession();
  segment.reset();
  window.location.reload();
  return {
    refresh_token: '',
    access_token: '',
    user_id: '',
    expires_in: ''
  };
};
